import Vue from 'vue'
import Router from 'vue-router'
 
// 导入视图组件
import IndexPage from '@/views/IndexPage.vue'
 
Vue.use(Router)
 
export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/index'  // 当用户访问根路径时，重定向
    },

    {
        path: '/index',
        name: 'index',
        component: IndexPage
   
    }
  ]
})